import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import ResumeRequestForm from "../components/ResumeRequestForm";
import "../styles/Resume.css";
import "../App.css";

const dummyURL =
  "https://firebasestorage.googleapis.com/v0/b/portfolio-christian-lira.firebasestorage.app/o/Resume%2FResume.pdf?alt=media";

/* Reusable modal that portals to <body> */
function ResumeModal({ open, onClose, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    document.body.classList.add("modal-open");
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.classList.remove("modal-open");
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <>
      <div
        className="resume-modal-overlay"
        onClick={(e) => e.currentTarget === e.target && onClose?.()}
      />
      <div
        className="resume-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Resume request"
      >
        <button className="close-button" onClick={onClose} aria-label="Close">
          ×
        </button>
        {children}
      </div>
    </>,
    document.body
  );
}

/* Simple Thank You screen shown after a valid request */
function ThankYouCard({ onClose }) {
  return (
    <div className="resume-form-container" style={{ textAlign: "center" }}>
      <h3 className="resume-form-title">Thanks for your request! 🎉</h3>
      <p className="resume-form-sub" style={{ marginBottom: "1rem" }}>
        Your secure resume link is ready. Click the button below to close this
        window and view it.
      </p>
      <div className="resume-actions" style={{ justifyContent: "center" }}>
        <button className="resume-submit" onClick={onClose}>
          Close and view resume
        </button>
      </div>
    </div>
  );
}

export default function Resume() {
  const [resumeURL, setResumeURL] = useState(dummyURL);
  const [showForm, setShowForm] = useState(false);
  const [showThanks, setShowThanks] = useState(false);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [linkError, setLinkError] = useState(null);

  const location = useLocation();

  // Close any modal on route change
  useEffect(() => {
    setShowForm(false);
    setShowThanks(false);
    setPendingUrl(null);
    setLinkError(null);
  }, [location.pathname]);

  // Called by the form AFTER Cloud Function returns { url, requestId }
  const handleVerified = ({ url }) => {
    if (!url) {
      setLinkError("No signed URL returned from server.");
      return;
    }
    setLinkError(null);
    setPendingUrl(url);
    setShowThanks(true);
  };

  // When user closes the Thank You, swap the resume URL and close modal
  const closeThanks = () => {
    if (pendingUrl) setResumeURL(pendingUrl);
    setPendingUrl(null);
    setShowThanks(false);
    setShowForm(false);
  };

  const modalOpen = showForm || showThanks;

  return (
    <div className="resume-container">
      <div className="max-w-4xl mx-auto">
        <h2 className="section-title">Request My Resume</h2>
        <p className="section-subtitle-instructions">The preview below is a sample. To obtain the full resume, click on "Request Resume" and fill out a quick form!</p>

        <div className="pdf-preview">
          <iframe
            src={resumeURL}
            title="Resume Preview"
            className="resume-iframe"
            width="100%"
          />
          <button className="request-button" onClick={() => setShowForm(true)}>
            Request Resume
          </button>
        </div>
      </div>

      <ResumeModal
        open={modalOpen}
        onClose={() => {
          setShowForm(false);
          setShowThanks(false);
          setLinkError(null);
        }}
      >
        {showThanks ? (
          <ThankYouCard onClose={closeThanks} />
        ) : (
          <div className="resume-form-container">
            <h3 className="resume-form-title">Request My Resume</h3>
            <p className="resume-form-sub">Tell me briefly who you are!</p>

            {linkError && (
              <div className="error-msg" style={{ marginBottom: "0.75rem" }}>
                {linkError}
              </div>
            )}

            <ResumeRequestForm
              onVerified={handleVerified}
              onCancel={() => setShowForm(false)}
              closeOnSuccess={false} // keep modal open so we can show Thank You
            />
          </div>
        )}
      </ResumeModal>
    </div>
  );
}








